import isString from "lodash/isString";
import { useEffect } from "react";

import { DrawEventType } from "../../utils/draw-modes-types";
import { useMap } from "../context";
import { v4 as uuid } from "uuid";
import { MapContextPolygonSource } from "../context/types";
import { usePolygon } from "../context/hooks";

export const useRadius = () => {
    const { map, functionType } = useMap();
    const { deletePolygon, updatePolygon, addPolygon } = usePolygon();

    const current = map.current;

    const handleRadius = (e: DrawEventType) => {
        const feature = e?.features[0];
        const isCircle: boolean = feature.properties?.isCircle || false;

        if (isCircle) {
            const id = feature.id;
            const setId = id ? id.toString() : uuid();

            if (e.type === "draw.delete" && isString(id)) {
                // Delete shape by keyboard
                deletePolygon(id);
            } else if (e.type === "draw.create") {
                addPolygon({
                    id: setId,
                    source: MapContextPolygonSource.drawnShape,
                    feature,
                    isSelected: false,
                });
            } else if (e.type === "draw.update") {
                updatePolygon({
                    id: setId,
                    feature,
                });
            }
        }
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (current) {
            current.on("draw.create", handleRadius);
            current.on("draw.delete", handleRadius);
            current.on("draw.update", handleRadius);
        }

        return () => {
            if (current) {
                current.off("draw.create", handleRadius);
                current.off("draw.delete", handleRadius);
                current.off("draw.update", handleRadius);
            }
        };
    }, [functionType, current]);

    return { handleRadius };
};
